import React, { Component } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';
import { FormField, InputField, FormErrorText } from 'v-c/Forms';
import { LargeCheckbox, StackedCheckboxContainer } from 'v-c/Forms/Checkboxes';
import styles from '../../Dropdowns.scss';

const BASE_KEY = 'components.dropdowns.export.views.name_export';

export default class ExportName extends Component {
    static displayName = displayName('Dropdowns/Export/ExportDropdownViews/ExportName',);

    static propTypes = {
        currentName: PropTypes.string.isRequired,
        error: PropTypes.object.isRequired,
        getMessage: PropTypes.func.isRequired,
        nameCharacterLimit: PropTypes.number.isRequired,
        onChangeName: PropTypes.func.isRequired,
        onCheckNotification: PropTypes.func.isRequired,
        sendNotification: PropTypes.bool.isRequired,
        userEmail: PropTypes.string.isRequired,
    };

    componentDidMount() {
        this.props.onChangeName(this.props.currentName);
    }

    onChangeName = e => this.props.onChangeName(e.target.value);

    onCheckNotification = () => {
        this.props.onCheckNotification(!this.props.sendNotification);
    };

    renderErrorMessage = type => (<FormErrorText
        error={`${BASE_KEY}.error.${type}`}
        field="export-name"
        values={{ characterLimit: this.props.nameCharacterLimit }}
                                  />);

    render() {
        const {
            currentName,
            error: { duplicateName, overLimit },
            getMessage,
            sendNotification,
            userEmail,
        } = this.props;
        const errorStatus = duplicateName || overLimit ? 'error' : void 0;

        return (
            <div>
                <div data-input="export-name" className={styles['export-name']}>
                    <FormField>
                        <InputField
                            status={errorStatus}
                            placeholder={getMessage(`${BASE_KEY}.placeholder`)}
                            onChange={this.onChangeName}
                            value={currentName}
                        />
                        {duplicateName && this.renderErrorMessage('duplicate')}
                        {overLimit && this.renderErrorMessage('over_limit')}
                    </FormField>
                </div>
                <div
                    data-input="export-notification"
                    className={styles['export-notification']}
                >
                    <div className={styles['export-header']}>
                        {getMessage(`${BASE_KEY}.notification.header`)}
                    </div>
                    <StackedCheckboxContainer>
                        <LargeCheckbox
                            checked={sendNotification}
                            onClick={this.onCheckNotification}
                        >
                            <span
                                data-value={userEmail}
                                className={styles['notification-text']}
                            >
                                {getMessage(`${BASE_KEY}.notification.send_to`)} 
                                {' '}
                                {userEmail}
                            </span>
                        </LargeCheckbox>
                    </StackedCheckboxContainer>
                </div>
            </div>
        );
    }
}
